var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPortfolioBalanceColorful = function SvgIcPortfolioBalanceColorful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9,
    cy: 18,
    r: 17.5,
    fill: "#E4F5F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 11.5,
    width: 17,
    height: 13,
    rx: 2,
    fill: "#16BD77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 16.5a1 1 0 0 1 1-1h5v4h-5a1 1 0 0 1-1-1v-2Z",
    fill: "#7BEBBC"
  })));
};
export default SvgIcPortfolioBalanceColorful;